module.exports = __webpack_public_path__ + "img/limit_doden.cfec4099.png";